import React, { useState } from 'react';

import { Button, Card, Form } from 'react-bootstrap';

import ModalSMS from '../../../common/components/ModalSMS';

const CandidateLogInComponent = (props: any) => {
  const [showSmsModal, setShowSmsModal] = useState(false);
  const [validatedSms, setValidatedSms] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleValidity = (event: any) => {
    setValidated(true);
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      setShowSmsModal(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleSmsValidation = (event: any) => {
    setValidatedSms(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    //todo check
    props.setStep(1);
    return <></>;
  };

  return (
    <>
      <h2 className="register-title text-center mb-0">Visiteurs</h2>
      <h3 className="register-subtitle text-center mt-0 mb-5">
        Authentifiez-vous pour accéder à votre espace sécurisé
      </h3>
      <Card className="w-75 p-4 mx-auto">
        <Form noValidate validated={validated} onSubmit={handleValidity}>
          <div className="d-flex flex-column gap-2 register-text-color">
            <p className="mt-0 mb-0 fw-bold">Numéro de téléphone</p>
            <Form.Group className="mb-4 mt-4" controlId="phone">
              <Form.Control
                type="text"
                placeholder="Numéro de téléphone"
                required
                value={props.phoneValue}
                onChange={(e) => props.setPhoneValue(e.target.value)}
              />
            </Form.Group>
            <Button type="submit" className="w-100" variant="primary" role="button">
              Se connecter
            </Button>
            <ModalSMS
              length={4}
              show={showSmsModal}
              setShow={setShowSmsModal}
              validated={validatedSms}
              handleSubmit={handleSmsValidation}
            />
          </div>
        </Form>
      </Card>
    </>
  );
};

export default CandidateLogInComponent;
